<script lang="ts">import { browser } from "$app/environment";
import { page } from "$app/stores";
import { cfgBrandTitle, cfgToThemeContentPath, stateUi } from "@infinitro/config";
import { betbyCurrentRoute, locale, loggedIn } from "@infinitro/global";
import CdnSeoMarkdownPanel from "./cdn-seo-markdown-panel.svelte";
import { applyStaticSeoPlaceholders, fetchLocaleRawWithEnFallback, renderSeoMarkdown } from "./fetch-markdown-seo";
const BRAND_NAME = cfgBrandTitle();
export let showMoreButton = true;
$: seoEnabled = $stateUi.seoText?.enabled !== false;
// Returns the sport sub-slug from a SvelteKit URL (contains 'sports'), or '' if not a sports route.
function extractSportSlug(path) {
	const parts = path.split("/").filter(Boolean);
	const sportsIndex = parts.indexOf("sports");
	if (sportsIndex < 0) return "";
	return parts[sportsIndex + 1] || "sports";
}
// Returns the sport slug from a Betby-internal path (e.g. '/american-football-16/matches' → 'american-football-16').
// Betby paths are relative to the sports basename and never contain 'sports'.
function extractBetbySportSlug(betbyPath) {
	if (!betbyPath) return "";
	const firstSegment = betbyPath.split("/").filter(Boolean)[0];
	return firstSegment || "sports";
}
let htmlContent = "";
let lastModified = "";
// Incremented on every fetch; only the most recent fetch's result is applied.
// Prevents betby's rapid route changes during init from discarding valid CDN responses.
let fetchId = 0;
// Adopts the copy only. The crawler link block must never be rendered to a visitor.
// The fetch below still runs: Betby navigation does not trigger a SvelteKit navigation.
(() => {
	if (!browser) return;
	const copy = document.querySelector("#seo-static-block .markdown-seo");
	if (!copy) return;
	htmlContent = copy.innerHTML;
	copy.remove();
})();
// betbySportSlug is the primary signal: updates immediately on every Betby navigation.
// pathSportSlug is the fallback: used on initial load before Betby fires its first onRouteChange.
$: betbySportSlug = extractBetbySportSlug($betbyCurrentRoute);
$: pathSportSlug = extractSportSlug($page.url.pathname);
$: sportSlug = betbySportSlug || pathSportSlug;
$: hasContent = htmlContent.trim().length > 0;
// Root sports page lives at /seo/sports/sports.{locale}.md (flat), not nested like sport slugs
function sportsCdnPath(slug, loc) {
	if (slug === "sports") return {
		localeUrl: cfgToThemeContentPath(`/seo/sports/sports.${loc}.md`),
		enUrl: cfgToThemeContentPath(`/seo/sports/sports.en.md`)
	};
	return {
		localeUrl: cfgToThemeContentPath(`/seo/sports/${slug}/${slug}.${loc}.md`),
		enUrl: cfgToThemeContentPath(`/seo/sports/${slug}/${slug}.en.md`)
	};
}
$: if ($loggedIn === false && sportSlug) {
	const id = ++fetchId;
	const loc = $locale;
	const { localeUrl, enUrl } = sportsCdnPath(sportSlug, loc);
	fetchLocaleRawWithEnFallback(localeUrl, enUrl, { cacheBust: true }).then(({ raw, lastModified: lm }) => {
		if (id !== fetchId || $loggedIn !== false) return;
		htmlContent = renderSeoMarkdown(applyStaticSeoPlaceholders(raw, BRAND_NAME));
		lastModified = lm;
	});
} else if ($loggedIn === true) {
	// `=== true`, not a plain else: loggedIn starts undefined; clearing then would wipe the seed.
	htmlContent = "";
	lastModified = "";
}
</script>

<svelte:head>
	{#if lastModified}
		<meta property="article:modified_time" content={lastModified} />
	{/if}
</svelte:head>

{#if seoEnabled && $loggedIn !== true && hasContent}
	<CdnSeoMarkdownPanel variant="contained" {htmlContent} {lastModified} {showMoreButton} />
{/if}
